import {DomainStore} from 'shared/store';
import _ from 'lodash';

const COUNTRY_TYPE = 'countries';
const COUNTRIES_ENDPOINT = 'countries';

const REGION_TYPE = 'regions';
const REGION_ENDPOINT = {
  with(countryId) {
    return `/countries/${countryId}/regions`;
  }
};

class CountryStore extends DomainStore {
  async loadCountries() {
    await this._compose([COUNTRIES_ENDPOINT]);
    return _.sortBy(this._getAll(COUNTRY_TYPE), 'name');
  }

  async getOrLoadRegions(countryCode, prefix = true) {
    if (_.isEmpty(this.__getRegions(countryCode, prefix))) {
      await this.__loadRegions(countryCode);
    }

    return this.__getRegions(countryCode, prefix);
  }

  __getRegions(countryCode, prefix) {
    const allRegions = this._getAll(REGION_TYPE);
    const selectedRegions = _.filter(allRegions, (region) => {
      return _.startsWith(region.id, `${countryCode}-`);
    });
    return _.map(selectedRegions, r => prefix ? r : {id: r.id.replace(countryCode + '-', ''), name: r.name});
  }

  async __loadRegions(countryCode) {
    await this._compose([REGION_ENDPOINT.with(countryCode)]);
  }

  getAllRegions() {
    return this._getAll(REGION_TYPE);
  }
}

const singleton = new CountryStore();

export default singleton;
